/**
 * 营销页面共享数据：导航、功能入口、页脚链接
 */

export interface NavItem {
  label: string
  href: string
}

export interface FeatureItem {
  title: string
  description: string
  href: string
  icon: 'clapperboard' | 'captions' | 'panels'
}

export const productMenuItems: FeatureItem[] = [
  {
    title: 'AI 剪辑',
    description: '从长素材中提取可编辑的短视频草稿',
    href: '/clipping',
    icon: 'clapperboard',
  },
  {
    title: '字幕与转写',
    description: '识别语音，生成可编辑字幕',
    href: '/captions',
    icon: 'captions',
  },
  {
    title: '专业视频编辑',
    description: '时间线、素材、文字、音频与导出控制',
    href: '/ai-video-editor',
    icon: 'panels',
  },
]

export const solutionMenuItems = [
  {
    title: '营销与增长',
    items: [
      ['电商与直播广告', '直播素材拆成卖点、钩子和行动版本'],
      ['品牌与效果广告', '快速生成多画幅、多节奏测试素材'],
      ['UGC 内容生产', '口播、体验、测评和原生感广告'],
    ],
  },
  {
    title: '知识与传播',
    items: [
      ['教育与课程', '长课切片、字幕、章节与知识短视频'],
      ['科普与讲解', '脚本、口播、配音和画面素材协同生成'],
      ['访谈与播客', '自动寻找观点、高光与完整语义片段'],
    ],
  },
  {
    title: '规模化内容',
    items: [
      ['长视频切片', '一次导入，生成一组持续发布内容'],
      ['多语言出海', '翻译、配音、字幕与本地化版本'],
      ['矩阵与批量分发', '统一品牌标准并批量输出平台版本'],
    ],
  },
]

export const productMenuColumns = [
  { title: 'AI 创作工具', links: ['口播视频草稿', 'AI 配音', '声音克隆', 'AI 生图', 'AI 生成视频', '数字人讲解'] },
  { title: '理解与加工', links: ['长视频智能切片', '高光片段识别', 'AI 字幕与翻译', '多语言视频包', '广告变体生成'] },
  { title: '专业编辑与交付', links: ['专业时间线', '字幕与关键帧', '品牌与画幅适配', '批量导出与发布'] },
]

export const mainNav: NavItem[] = [
  { label: '专业编辑', href: '/app' },
  { label: '价格', href: '/pricing' },
  { label: 'MCP', href: '/mcp' },
  { label: '帮助', href: '/help' },
]

export interface FooterLink {
  label: string
  href: string
  isExternal?: boolean
}

export interface FooterColumn {
  title: string
  links: FooterLink[]
}

export const footerColumns: FooterColumn[] = [
  {
    title: '产品',
    links: [
      { label: 'AI 初稿与工作流', href: '/' },
      { label: '专业编辑', href: '/app' },
      { label: 'MCP 服务', href: '/mcp' },
    ],
  },
  {
    title: '公司',
    links: [
      { label: '价格', href: '/pricing' },
      { label: '帮助中心', href: '/help', isExternal: false },
      { label: '文档', href: '/docs', isExternal: false },
    ],
  },
]

export const legalLinks: NavItem[] = [
  { label: '隐私政策', href: '#' },
  { label: '服务条款', href: '#' },
]

export interface SocialLink {
  label: string
  href: string
  icon: 'youtube' | 'tiktok' | 'instagram' | 'facebook' | 'x' | 'linkedin'
}

export const socialLinks: SocialLink[] = []
